import { render } from "./team-goal-view.vue?vue&type=template&id=4eefe4f6"
import script from "./team-goal-view.vue?vue&type=script&lang=js"
export * from "./team-goal-view.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__